import {createSlice} from '@reduxjs/toolkit'

export interface SnackbarState {
    snackbarOpen: boolean,
    snackbarMessage: string,
    snackbarSeverity: "success" | "info" | "warning" | "error"
}

const initialState: SnackbarState = {
    snackbarOpen: false,
    snackbarMessage: '',
    snackbarSeverity: "info",
}

export const snackbarSlice = createSlice({
    name: 'snackbar',
    initialState,
    reducers: {
        setSnackbarOpen(state, action){
            state.snackbarOpen = true;
            state.snackbarMessage = action.payload.snackbarMessage;
            state.snackbarSeverity = action.payload.snackbarSeverity;

        },
        clearSnackbar(state){
            state.snackbarOpen = false;
            state.snackbarMessage = '';
            state.snackbarSeverity = "info";
        },
    },
})

// Action creators are generated for each case reducer function
export const { setSnackbarOpen, clearSnackbar } = snackbarSlice.actions

export default snackbarSlice.reducer